import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {FrameTypesEnum} from '../../../../../models/api/apiTypes';
import {
  updateSelectedSideFrameIdAction,
  updateSidepanelMultiViewSelectedFrameIdsAction,
} from '../../../../../store/data/localPreferences/localPreferencesActions';
import {
  getSelectedSideFrameId,
  getSidepanelMultiViewDetails,
} from '../../../../../store/data/localPreferences/localPreferencesSelectors';
import {getSortedVisiblePanelFrames} from '../../../../../store/stateless/sidePanelFrameSelectors';
import {MultiViewButton} from './multiViewButton';

/*
 * Selectors.
 */

function makeGetIsMultiViewSelected() {
  return createSelector(
    [getSelectedSideFrameId],
    (selectedFrameId) => selectedFrameId === FrameTypesEnum.MULTI_VIEW,
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  visibleFrames: getSortedVisiblePanelFrames,
  multiViewDetails: getSidepanelMultiViewDetails,
  isMultiViewSelected: makeGetIsMultiViewSelected(),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  updateSelectedSideFrameId: updateSelectedSideFrameIdAction,
  updateSidepanelMultiViewSelectedFrameIds: updateSidepanelMultiViewSelectedFrameIdsAction,
}));

export const MultiViewButtonContainer = connect(mapStateToProps, mapDispatchToProps)(MultiViewButton);
